import { render } from "./studioArticle.vue?vue&type=template&id=3a2eaeca&scoped=true"
import script from "./studioArticle.vue?vue&type=script&lang=js"
export * from "./studioArticle.vue?vue&type=script&lang=js"

import "./studioArticle.vue?vue&type=style&index=0&id=3a2eaeca&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a2eaeca"]])

export default __exports__